import BaseWidget from '../baseWidget';
import moment from 'moment-timezone';
import pluralize from 'pluralize';

export default class AllTimeRevivalDatesWidget extends BaseWidget {
  get revivalDates() {
    return this.props.revivalDates;
  }

  get dates() {
    return [
      { value: this.revivalDates.preparationStartDate, daysCount: this.revivalDates.preparationDaysCount},
      { value: this.revivalDates.startDate, daysCount: this.revivalDates.revivalDaysCount }
    ];
  }

  get tickValues() {
    return this.dates.map((date) => this.formatDates(date.value));
  }

  get tickFormat() {
    return this.dates.map((date, index) => this.formatValues(date.daysCount, index));
  }

  formatDates(date) {
    return moment.unix(date).format('MMM DD');
  }

  formatValues(daysCount, index) {
    switch(index) {
      case 0:
        return `Event Preparation\n${pluralize('day', daysCount, true)}`;
      case 1:
        return `Event ${pluralize('day', daysCount, true)}`;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/allTime/allTimeRevivalDatesWidget.js